/**
 * Junta produtos em rascunho (e os que passaram do teto do Liquid)
 * ao JSON que o tema monta com collections.all.
 * Fonte: GET /apps/wishlist/photo-catalog (app gm-wishlist).
 * Se o app não responder, as ferramentas seguem só com o publicado.
 */
(function (global) {
  var ENDPOINT = '/apps/wishlist/photo-catalog';
  var pending = null;

  function sized(url, width) {
    if (!url) return null;
    try {
      var u = new URL(url, global.location.origin);
      u.searchParams.set('width', String(width));
      return u.toString();
    } catch (e) {
      return url;
    }
  }

  function base(raw) {
    var img = raw && raw.image;
    var draft = !!(raw && String(raw.status).toUpperCase() === 'DRAFT');
    return {
      handle: raw.handle,
      title: raw.title || '',
      url: raw.url || '/products/' + raw.handle,
      modelo: raw.modelo || '',
      modeloId: raw.modeloId || '',
      modeloLabel: raw.modeloNome || '',
      cor: raw.cor || raw.title || '',
      price: raw.priceCents || 0,
      draft: draft,
      status: raw.status || '',
      srcW: img ? img.width : null,
      srcH: img ? img.height : null,
      width: img ? img.width : null,
      height: img ? img.height : null,
      updatedAt: raw.updatedAt || 0,
      updatedLabel: raw.updatedLabel || '',
      mainUrl: img ? sized(img.url, 1200) : null,
      mainUrlHi: img ? sized(img.url, 3200) : null,
      cardUrl: img ? sized(img.url, 800) : null,
      thumbUrl: img ? sized(img.url, 240) : null,
      thumb: img ? sized(img.url, 800) : null,
      main: img ? sized(img.url, 1200) : null,
    };
  }

  function mapEditor(raw) {
    var row = base(raw);
    if (!row.mainUrl) return null;
    return row;
  }

  function mapRef(raw) {
    var row = base(raw);
    if (!row.mainUrlHi) return null;
    return {
      handle: row.handle,
      title: row.title,
      url: row.url,
      modelo: row.modelo,
      modeloId: row.modeloId,
      modeloLabel: row.modeloLabel,
      cor: row.cor,
      srcW: row.srcW,
      srcH: row.srcH,
      mainUrlHi: row.mainUrlHi,
      draft: row.draft,
    };
  }

  function mapAprov(raw) {
    var row = mapRef(raw);
    if (!row) return null;
    row.previewUrl = row.mainUrlHi;
    return row;
  }

  function mapSize(raw) {
    var row = base(raw);
    return {
      handle: row.handle,
      title: row.title,
      url: row.url,
      thumb: row.thumb,
      width: row.width,
      height: row.height,
      draft: row.draft,
    };
  }

  function mapLabGrid(raw) {
    var row = base(raw);
    return {
      handle: row.handle,
      title: row.title,
      url: row.url,
      updatedAt: row.updatedAt,
      updatedLabel: row.updatedLabel,
      thumb: row.thumb,
      main: row.main,
      width: row.width,
      height: row.height,
      draft: row.draft,
    };
  }

  function load() {
    if (pending) return pending;
    pending = new Promise(function (resolve) {
      var settled = false;
      function finish(list) {
        if (settled) return;
        settled = true;
        resolve(Array.isArray(list) ? list : []);
      }
      var timer = setTimeout(function () {
        finish([]);
      }, 8000);
      fetch(ENDPOINT, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      })
        .then(function (res) {
          if (!res.ok) return null;
          return res.json();
        })
        .then(function (data) {
          clearTimeout(timer);
          if (!data || data.ok !== true || !Array.isArray(data.products)) {
            finish([]);
            return;
          }
          finish(data.products);
        })
        .catch(function () {
          clearTimeout(timer);
          finish([]);
        });
    });
    return pending;
  }

  /**
   * Mantém a lista do Liquid e acrescenta handles que só existem no Admin.
   * @param {Array<any>} liquidList
   * @param {Array<any>} catalog
   * @param {function(any): any} mapFn
   */
  function merge(liquidList, catalog, mapFn) {
    var seen = Object.create(null);
    var out = [];
    (liquidList || []).forEach(function (p) {
      if (!p || !p.handle || seen[p.handle]) return;
      seen[p.handle] = true;
      out.push(p);
    });
    (catalog || []).forEach(function (raw) {
      if (!raw || !raw.handle || seen[raw.handle]) return;
      var mapped = mapFn ? mapFn(raw) : raw;
      if (!mapped || !mapped.handle) return;
      seen[mapped.handle] = true;
      out.push(mapped);
    });
    return out;
  }

  global.GmPhotoCatalog = {
    load: load,
    merge: merge,
    mapEditor: mapEditor,
    mapLabMain: mapEditor,
    mapRef: mapRef,
    mapAprov: mapAprov,
    mapSize: mapSize,
    mapLabGrid: mapLabGrid,
  };
})(window);
